import { type FC, useState } from 'react'
import classNames from 'classnames'
import { Button } from '../../../../components/Button/Button'
import { Spinner } from '../../../../components/Spinner/Spinner'
import { type SmsTemplatePurpose } from '../../../../models/Scheduling'
import { selectSafeAuthenticatedUser } from '../../../../store/auth/authSlice'
import { useAppSelector } from '../../../../store/hooks'
import { useGetSchedulingSmsTemplatesQuery } from '../../../../store/scheduling/scheduling'
import { TemplateText } from './messageTemplateCards'
import { SMS_TEMPLATE_PURPOSES } from './smsTemplatePurposes'

interface SmsTextPreviewProps {
  purpose: SmsTemplatePurpose
}

export const SmsTextPreview: FC<SmsTextPreviewProps> = ({ purpose }) => {
  const [isOpen, setIsOpen] = useState(false)
  const accountId = useAppSelector(selectSafeAuthenticatedUser).accountId
  const { data: templates = [], isLoading, isError } = useGetSchedulingSmsTemplatesQuery({ accountId }, { skip: !isOpen })
  const template = templates.find((candidate) => candidate.purpose === purpose)
  const note = SMS_TEMPLATE_PURPOSES.find((info) => info.purpose === purpose)?.note
  const regionId = `sms-text-${purpose}`

  return (
    <div className='d-flex flex-column gap-2 pt-2'>
      <Button
        type='button'
        className='d-flex align-items-center align-self-start gap-1 p-0 paragraph-small zocks-text-primary text-decoration-underline'
        aria-expanded={isOpen}
        aria-controls={regionId}
        onClick={() => setIsOpen((current) => !current)}
      >
        {isOpen ? 'Hide text' : 'Show text'}
        <i aria-hidden='true' className={classNames('bi', isOpen ? 'bi-chevron-up' : 'bi-chevron-down')} />
      </Button>
      {isOpen ? (
        <div
          id={regionId}
          className='d-flex flex-column gap-2 px-3 py-2 border rounded-3 zocks-border-color-gray-200 zocks-bg-color-gray-100 paragraph-small zocks-text-gray-900'
        >
          {isLoading ? <Spinner size='sm' /> : null}
          {isError ? <span className='zocks-text-gray-600'>Could not load the text. Please try again.</span> : null}
          {!isLoading && !isError ? (
            template != null ? (
              <>
                <span>
                  <span className='zocks-text-gray-400'>FROM</span> Your sending number
                </span>
                <span className='paragraph-medium'>
                  <TemplateText text={template.body} />
                </span>
                {note ? <span className='zocks-text-gray-600'>{note}</span> : null}
              </>
            ) : (
              <span className='zocks-text-gray-600'>This template isn&apos;t available yet.</span>
            )
          ) : null}
        </div>
      ) : null}
    </div>
  )
}
